import React from 'react';

import { LeadModel } from '@/typings/models/Lead';
import { useHasMarketingDataAccess } from '@/utils/hooks';

const LeadSource = ({lead, fallback}: {lead: LeadModel, fallback?: React.ReactElement | string}) => {
  const hasMarketingDataAccess = useHasMarketingDataAccess()
  if (!hasMarketingDataAccess) return null;
  
  return <div style={{minWidth: 60}}>
    {lead?.lead_source?.name || fallback}
  </div>
}

export default LeadSource
